export const LeftLines: React.FC = () => {
	return (
		<svg
			width="52"
			height="256"
			viewBox="0 0 52 256"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0_4819_34757"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="52"
				height="256"
			>
				<path
					d="M48.21 0H18.6151C17.0251 0 15.7352 1.29007 15.7352 2.88007V39.9901C15.7352 41.5801 14.4451 42.8699 12.8551 42.8699H2.88007C1.29007 42.8699 0 44.16 0 45.75V252.315C0 253.905 1.29007 255.195 2.88007 255.195H32.475C34.065 255.195 35.3551 253.905 35.3551 252.315V215.205C35.3551 213.615 36.6452 212.325 38.2352 212.325H48.21C49.8 212.325 51.0901 211.035 51.0901 209.445V2.88007C51.0901 1.29007 49.8 0 48.21 0Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_4819_34757)">
				<path
					d="M23.4301 -650.91H21.9301V142.74H23.4301V-650.91Z"
					fill="#363636"
				/>
				<path
					d="M38.7151 -650.91H37.2151V142.74H38.7151V-650.91Z"
					fill="#363636"
				/>
				<path
					d="M8.14514 -650.91H6.64514V142.74H8.14514V-650.91Z"
					fill="#363636"
				/>
				<path
					d="M23.4301 142.89H21.9301V936.54H23.4301V142.89Z"
					fill="#363636"
				/>
				<path
					d="M38.7151 142.89H37.2151V936.54H38.7151V142.89Z"
					fill="#363636"
				/>
				<path
					d="M8.14514 142.89H6.64514V936.54H8.14514V142.89Z"
					fill="#363636"
				/>
			</g>
		</svg>
	)
}

export const BottomLines: React.FC = () => {
	return (
		<svg
			width="270"
			height="211"
			viewBox="0 0 270 211"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0_4819_34758"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="270"
				height="211"
			>
				<path
					d="M204.255 65.7227V36.3601C204.255 33.9751 202.32 32.04 199.935 32.04H110.88C108.495 32.04 106.56 30.1052 106.56 27.7202V4.3201C106.56 1.9351 104.625 0 102.24 0H4.3201C1.9351 0 0 1.9351 0 4.3201V135.81C0 138.195 1.9351 140.13 4.3201 140.13H87.5701C89.9551 140.13 91.8902 142.065 91.8902 144.45V167.85C91.8902 170.235 93.825 172.17 96.21 172.17H158.963C161.348 172.17 163.283 174.105 163.283 176.49V205.852C163.283 208.237 165.218 210.173 167.603 210.173H265.523C267.908 210.173 269.843 208.237 269.843 205.852V74.3626C269.843 71.9776 267.908 70.0425 265.523 70.0425H208.575C206.19 70.0425 204.255 68.1077 204.255 65.7227Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_4819_34758)">
				<path
					d="M265.433 -1018.12H263.183V172.35H265.433V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M196.65 -1018.12H194.4V172.35H196.65V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M104.963 -1018.12H102.713V172.35H104.963V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M242.505 -1018.12H240.255V172.35H242.505V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M150.795 -1018.12H148.545V172.35H150.795V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M59.1075 -1018.12H56.8575V172.35H59.1075V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M13.2526 -1018.12H11.0026V172.35H13.2526V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M219.578 -1018.12H217.328V172.35H219.578V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M173.723 -1018.12H171.473V172.35H173.723V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M127.868 -1018.12H125.618V172.35H127.868V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M82.0352 -1018.12H79.7852V172.35H82.0352V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M36.1802 -1018.12H33.9302V172.35H36.1802V-1018.12Z"
					fill="#363636"
				/>
				<path
					d="M265.433 172.575H263.183V1363.05H265.433V172.575Z"
					fill="#363636"
				/>
				<path
					d="M196.65 172.575H194.4V1363.05H196.65V172.575Z"
					fill="#363636"
				/>
				<path
					d="M104.963 172.575H102.713V1363.05H104.963V172.575Z"
					fill="#363636"
				/>
				<path
					d="M242.505 172.575H240.255V1363.05H242.505V172.575Z"
					fill="#363636"
				/>
				<path
					d="M150.795 172.575H148.545V1363.05H150.795V172.575Z"
					fill="#363636"
				/>
				<path
					d="M59.1075 172.575H56.8575V1363.05H59.1075V172.575Z"
					fill="#363636"
				/>
				<path
					d="M13.2526 172.575H11.0026V1363.05H13.2526V172.575Z"
					fill="#363636"
				/>
				<path
					d="M219.578 172.575H217.328V1363.05H219.578V172.575Z"
					fill="#363636"
				/>
				<path
					d="M173.723 172.575H171.473V1363.05H173.723V172.575Z"
					fill="#363636"
				/>
				<path
					d="M127.868 172.575H125.618V1363.05H127.868V172.575Z"
					fill="#363636"
				/>
				<path
					d="M82.0352 172.575H79.7852V1363.05H82.0352V172.575Z"
					fill="#363636"
				/>
				<path
					d="M36.1802 172.575H33.9302V1363.05H36.1802V172.575Z"
					fill="#363636"
				/>
			</g>
		</svg>
	)
}

export const TopLines: React.FC = () => {
	return (
		<svg
			width="134"
			height="92"
			viewBox="0 0 134 92"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0_4819_35057"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="134"
				height="92"
			>
				<path
					d="M133.7 34.4402V3.84009C133.7 1.72009 131.98 0 129.86 0H37.66C35.54 0 33.8201 1.72009 33.8201 3.84009V19.4602C33.8201 21.5802 32.1 23.3 29.98 23.3H3.83997C1.71997 23.3 0 25.0201 0 27.1401V68.8401C0 70.9601 1.71997 72.6802 3.83997 72.6802H12.6801C14.8001 72.6802 16.52 74.4 16.52 76.52V87.9602C16.52 90.0802 18.24 91.8 20.36 91.8H117.16C119.28 91.8 121 90.0802 121 87.9602V57.3601C121 55.2401 119.28 53.52 117.16 53.52H108.32C106.2 53.52 104.48 51.8002 104.48 49.6802V42.1001C104.48 39.9801 106.2 38.26 108.32 38.26H129.86C131.98 38.26 133.7 36.5402 133.7 34.4202V34.4402Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_4819_35057)">
				<path
					d="M100.08 -271.86H98.0796V786.34H100.08V-271.86Z"
					fill="#363636"
				/>
				<path
					d="M59.3198 -271.86H57.3198V786.34H59.3198V-271.86Z"
					fill="#363636"
				/>
				<path
					d="M18.5596 -271.86H16.5596V786.34H18.5596V-271.86Z"
					fill="#363636"
				/>
				<path
					d="M120.46 -271.86H118.46V786.34H120.46V-271.86Z"
					fill="#363636"
				/>
				<path
					d="M79.6997 -271.86H77.6997V786.34H79.6997V-271.86Z"
					fill="#363636"
				/>
				<path
					d="M38.9399 -271.86H36.9399V786.34H38.9399V-271.86Z"
					fill="#363636"
				/>
			</g>
		</svg>
	)
}
